import React, { useState, useContext, useEffect } from 'react';
import "../../Styles/OrderCheckout.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from '../Context/PacksContext';
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import {MedicalContext} from '../Context/MedicalContext';
import { BasketContext } from '../Context/BasketContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import packslist from "../../../JSONS/updatedPacks.json"
import examslist from "../../../JSONS/updatedExams.json"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Payment } from '@mercadopago/sdk-react';
import { initMercadoPago } from '@mercadopago/sdk-react';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';

function OrderCheckout() {
  let publicKey = process.env.REACT_APP_MP_PUBLIC_KEY ? process.env.REACT_APP_MP_PUBLIC_KEY : "TEST-c2c23c3c-0b13-4388-97bd-699e852d4084"
  initMercadoPago(publicKey,{locale:'es-CL'});

  const Navigate = useNavigate();

  const MySwal = withReactContent(Swal)

  const {
     RelatedExams, SetRelatedExams
  } = useContext(MedicalContext);

  const {
    ExamsPerProduct, SetExamsPerProduct, SetAdded, SetPurchased
    //ExamediSelected, SetExamediSelected, ExamediRegion, SetExamediRegion, ExamediCommune, SetExamediCommune, ExamediAllowed, SetExamediAllowed, ExamediWrong
  } = useContext(Packs);

  const {
    setOrderExamsCodes, OrderExamsCodes, setDiscounted
  } = useContext(BasketContext);

  const [BasketPacks, SetBasketPacks] = useState(window.localStorage.getItem('BasketPacks') ? JSON.parse(window.localStorage.getItem('BasketPacks')) : []);
  //const Recom = RelatedExams.length === 0 & UnrelatedExams.length === 0 ? 0 : RelatedExams.length !== 0 & UnrelatedExams.length !== 0 ? 2 : 1

  const [ExamDetails, setExamDetails] = useState(false);
  const [OpenBlock, setOpenBlock] = useState(-1);
  const [shown, setShown] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfBlocks, setNumberOfBlocks] = useState(0);
  const [examsShown, setExamsShown] = useState(Array.from([0, 1, 2]));
  const [packOne, setPackOne] = useState([]);
  const [packOneDer, setPackOneDer] = useState([]);
  //const [OneTime, setOneTime] = useState(true);
  //const [ExamediFonasa, setExamediFonasa] = useState("");
  //const [RecalcFonasa, setRecalcFonasa] = useState(false);

  const [onetime, setOnetime] = useState(true)
  const [onetime2, setOnetime2] = useState(true)
  const [onetime4, setOnetime4] = useState(false)
  const [TOSMissing, setTOSMissing] = useState(false)
  //const [ExamediIncomplete, setExamediIncomplete] = useState(false)
  const [ValidCoupon, setValidCoupon] = useState('')
  const [PriceTotal, setPriceTotal] = useState(RelatedExams.length === 0 ? 0 : 990)
  const [Discount, setDiscount] = useState(0)
  const [Loading, setLoading] = useState(false)
  const [Loading2, setLoading2] = useState(false)
  const [Coupon, setCoupon] = useState("")

  const [PreferenceID, setPreferenceID] = useState(null);
  const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;

  const customization = {
    paymentMethods: {
      creditCard: "all",
      prepaidCard: "all",
      debitCard: "all",
      mercadoPago: "all",
    },
    visual: {
      hideFormTitle: true,
      style: {
        theme: "flat",
        customVariables: {
          formPadding: "10px",
          fontSizeLarge: "15px"
        },
      },
    },
    formPadding: "10px"
  };

  const onSubmit = async (
      { selectedPaymentMethod, formData }
  ) => {
      // callback llamado al hacer clic en el botón enviar datos
      SetPurchased(true)

      return new Promise((resolve, reject) => {
        fetch("https://ymc-doc-api.azurewebsites.net/process_payment", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((response) => {
            // recibir el resultado del pago
            console.log("Payment response:", response);
            
            if(response.status === "approved") {
              Navigate("/orden-medica/descargar-orden")
            } else if(response.status === "in_process") {
              // Validate payment ID exists before redirecting
              if (response.id) {
                Navigate("/orden-medica/esperando-pago?paymentID=".concat(response.id))
              } else {
                console.error("Payment ID missing in in_process response");
                MySwal.fire({
                  icon: "error",
                  title: "Error en el proceso de pago",
                  text: "No se pudo obtener el ID del pago. Por favor intente nuevamente o contacte a soporte.",
                  showConfirmButton: true,
                  allowOutsideClick: false
                }).then(() => {
                  setPreferenceID(null)
                  Navigate("/orden-medica")
                })
              }
            } else if(response.status === "rejected") {
              MySwal.fire({
                icon: "error",
                title: "El pago fue rechazado",
                text: "Por favor revise los datos ingresados",
                showConfirmButton: true,
                allowOutsideClick: false
              }).then((result) => {
                if (result.isConfirmed) {
                  setPreferenceID(null)
                  Navigate("/orden-medica")
                }
              })
            } else {
              // Handle unexpected status
              console.error("Unexpected payment status:", response.status);
              MySwal.fire({
                icon: "warning",
                title: "Estado de pago desconocido",
                text: "El pago tiene un estado inesperado. Por favor revise el historial de órdenes o contacte a soporte.",
                showConfirmButton: true,
                allowOutsideClick: false
              }).then(() => {
                setPreferenceID(null)
                Navigate("/orden-medica")
              })
            }
            resolve()
        })
          .catch((error) => {
            // manejar la respuesta de error al intentar crear el pago
            console.error("Payment processing error:", error);
            MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al procesar el pago",
              text: "Por favor inténtelo más tarde",
              showConfirmButton: true,
              allowOutsideClick: false
            }).then((result) => {
              if (result.isConfirmed) {
                Navigate("/orden-medica")
              }
            })
            reject(error)
        });
      });
  };
  const onError = async (error) => {
      // callback llamado para todos los casos de error de Brick
      MySwal.fire({
          icon: "error",
          title: "Ocurrió un error al procesar el pago",
          text: "Por favor inténtelo más tarde",
          showConfirmButton: true
      });
      console.log(error);
  };
  const onReady = async () => {
      //console.log(PreferenceID)
  };

  const createPreference = async () => {
    setLoading2(true)
    
    let titled = "Packs de Exámenes:"
    if(window.localStorage.getItem("BasketPacks") && JSON.parse(window.localStorage.getItem("BasketPacks")).length !== 0) {
      titled += JSON.parse(window.localStorage.getItem("BasketPacks")).map((med) => String(packslist[med].name)).join(', ')
    }
    if(window.localStorage.getItem("RelatedExams") && JSON.parse(window.localStorage.getItem("RelatedExams")).length !== 0) {
      titled += ", Exámenes Recomendados"
    }

    let parameters = {
      title: titled,
      quantity: 1,
      price: PriceTotal
    }
  
    let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters)
    };

    try{
      let resp = await fetch("https://ymc-doc-api.azurewebsites.net/create_preference", requestOptions)
      if (resp.status !== 200){
          MySwal.fire({
              icon: "error",
              title: "Ocurrió un error obteniendo los datos",
              text: "Por favor inténtelo más tarde",
              showConfirmButton: true
          });
          return false;
      }
      let data = await resp.json();
      if(data) {
        setPreferenceID(data.id)
        let tmp = document.getElementById('Step1')
        let tmp2 = document.getElementById('Step2')
        tmp.className = tmp.className.replace("OrderCheckoutDiv", "OrderCheckoutDivHidden");
        tmp2.className = tmp2.className.replace("OrderCheckoutDivHidden", "OrderCheckoutDiv");
      }
      setLoading2(false)
      return
    }
    catch(error){
      MySwal.fire({
        icon: "error",
        title: "Ocurrió un error al subir los datos",
        text: "Por favor inténtelo más tarde",
        showConfirmButton: true
      });
      setLoading2(false)
      return false;
    }
  }

  //const communeRM = ["Calera De Tango","Cerrillos","Cerro Navia","Colina","Conchali","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla De Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Las Condes","Lo Barnechea","Lo Prado","Maipú","Macul","Ñuñoa","Padre Hurtado","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquií","San José de Miapo","San Miguel","San Ramón","Santiago","Talagante","Vitacura"]
  //const communeAN = ["Antofagasta"]
  //const communeCO = ["Coquimbo","La Serena"]
  //const communeVA = ["Concón","Limache","Placilla","Quillota","Quilpué"]
  //const communeBI = ["Chiguayante","Concepción","Coronel","Hualpén","Hualqui","Penco","San Pedro de la Paz","Talcahuano","Tomé"]

  //useEffect(() => {
    //if(document.getElementById('FullForm') && OneTime) {
    //  if(ExamediSelected) {
    //    document.getElementById('Examedi').checked = true
    //    document.getElementById("ExamediForm").className = document.getElementById("ExamediForm").className.replace(" OrderCheckoutInnerDiv2BlockHidden", "");
    //    SetExamediSelected(true)
    //    if(document.getElementById('RegionSelect')) document.getElementById('RegionSelect').value=ExamediRegion;
    //    if(document.getElementById('CommuneSelect')) document.getElementById('CommuneSelect').value=ExamediCommune;
    //    if(document.getElementById('ExamediAllowed')) document.getElementById('ExamediAllowed').checked= ExamediAllowed ? true : false;
    //  }
    //  CalculateFonasa()
    //  setOneTime(false)
    //}
    //if(RecalcFonasa) {
    //  CalculateFonasa()
    //  setRecalcFonasa(false)
    //}
  //})

  useEffect(() => {
    if(numberOfBlocks !== BasketPacks.length & OpenBlock !== -1) {
      setExamDetails(false)
      let tmp6 = document.getElementsByClassName("OrderCheckoutInnerBoxLowerLines")
      let tmp7 = document.getElementsByClassName("OrderCheckoutInnerBoxLowerLinesPageDots")
      //let tmp8 = document.getElementsByClassName("OrderCheckoutInnerBoxRiskLines")
      for(let i=0;i<tmp6.length;i++) {
        if(!tmp6[i].classList.contains("OrderCheckoutHidden")) {
          tmp6[i].className += " OrderCheckoutHidden"
          tmp7[i].className += " OrderCheckoutHidden"
          //tmp8[i].className += " OrderCheckoutHidden"
        }
      }
      setCurrentPage(1)
      if(OpenBlock <= BasketPacks.length) {
        let tmp4 = document.getElementById('pageDot'.concat(currentPage))
        tmp4.className = tmp4.className.replace(" ActiveDot", "");
        let tmp5 = document.getElementById('pageDot1')
        tmp5.className += " ActiveDot"
      }
      //setRecalcFonasa(true)
    }
  }, [numberOfBlocks, BasketPacks, OpenBlock, currentPage])

  //function CalculateFonasa() {
  //  let exams = []
  //  for (const property in ExamsPerProduct) {
  //    exams.push(...ExamsPerProduct[property]['exams']);
  //  }
  //  exams.push(...RelatedExams)
  //  let uniques = [...new Set(exams)]
//
  //  let totalexams = uniques.length
  //  let accounted = 0
  //  let fonprice = 0
  //  for(let i=0;i<uniques.length;i++) {
  //    if(examslist[exams[i]].fonasa) {
  //      fonprice += examslist[exams[i]].fonasa
  //      accounted += 1
  //    }
  //  }
  //  setExamediFonasa({total: totalexams, acc: accounted, price: fonprice})
  //}

  function ChangeExamPage(step, length) {
    let tmp = document.getElementById('pageDot'.concat(currentPage))
    //console.log(tmp,currentPage)
    tmp.className = tmp.className.replace(" ActiveDot", "");
    let tmp2 = document.getElementById('pageDot'.concat(currentPage + (step/3)))
    //console.log(tmp2,currentPage + (step/3))
    tmp2.className += " ActiveDot"

    setCurrentPage(currentPage + (step/3))
    //console.log(shown,length)
    if(shown === length - 1 & step > 0) {
      setExamsShown(Array.from([0], (x) => x + shown + step))
    } else if (shown === length - 2 & step > 0) {
      setExamsShown(Array.from([0, 1], (x) => x + shown + step))
    } else setExamsShown(Array.from([0, 1, 2], (x) => x + shown + step))
    setShown(shown + step)

    //console.log(shown,examsShown,currentPage)
  }

  function ShowDetails(block,id1,id3,idx) {
    //console.log(block,OpenBlock,ExamsPerProduct[BasketPacks[block-1]].exams.map(a => examslist[a]),exams)
    let packs = JSON.parse(window.localStorage.getItem('BasketPacks'))
    let exams = JSON.parse(window.localStorage.getItem('ExamsPerProduct'))
    let allExams = block !== 0 ?
        exams[packs[idx]].exams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== "")
        : idx
    if(allExams.length === 2) {
      setExamsShown(Array.from([0, 1]))
    } else if(allExams.length === 1){
      setExamsShown(Array.from([0]))
    } else {
      setExamsShown(Array.from([0, 1, 2]))
    }
    let tmp = document.getElementById(id1)
    let tmp3 = document.getElementById(id3)
    let tmp6 = document.getElementsByClassName("OrderCheckoutInnerBoxLowerLines")
    let tmp7 = document.getElementsByClassName("OrderCheckoutInnerBoxLowerLinesPageDots")
    if(ExamDetails & block === OpenBlock) {
      setExamDetails(false)
      if(tmp) tmp.className += " OrderCheckoutHidden"
      if(tmp3) tmp3.className += " OrderCheckoutHidden"
      let tmp4 = document.getElementById('pageDot'.concat(currentPage))
      if(tmp4) tmp4.className = tmp4.className.replace(" ActiveDot", "");
      setCurrentPage(1)
      let tmp5 = document.getElementById('pageDot1')
      if(tmp5) tmp5.className += " ActiveDot"

    } else {
      setExamDetails(true)
      for(let i=0;i<tmp6.length;i++) {
        if(!tmp6[i].classList.contains("OrderCheckoutHidden")) {
          if(tmp6[i]) tmp6[i].className += " OrderCheckoutHidden"
          if(tmp7[i]) tmp7[i].className += " OrderCheckoutHidden"
        }
      }
      setNumberOfBlocks(packs.length)
      if(block !== 0) {
        setPackOne(exams[packs[block-1]].exams.filter(b => examslist[b].emission !== "Derivaciones" && examslist[b].emission !== "").map(a => examslist[a]))
        setPackOneDer(exams[packs[block-1]].exams.filter(b => examslist[b].emission === "Derivaciones").map(a => examslist[a]))
      } else {
        setPackOne(RelatedExams.filter(b => examslist[b].emission !== "Derivaciones" && examslist[b].emission !== "").map(a => examslist[a]))
        setPackOneDer(RelatedExams.filter(b => examslist[b].emission === "Derivaciones").map(a => examslist[a]))
      }
      setOpenBlock(block)
      tmp.className = tmp.className.replace(" OrderCheckoutHidden", "");
      if(tmp3) tmp3.className = tmp3.className.replace(" OrderCheckoutHidden", "");
      setCurrentPage(1)
      setShown(0)
    }
  }

  function EliminateBlock(pack) {
    if(pack === "Recommended") {
      SetRelatedExams([])
      window.localStorage.setItem("RelatedExams",JSON.stringify([]))
      setOnetime4(true)
    } else {
      let listOfPacks = JSON.parse(window.localStorage.getItem('BasketPacks'))
      let examsOfPacks = JSON.parse(window.localStorage.getItem('ExamsPerProduct'))
      //console.log(listOfPacks,examsOfPacks)
      let index = listOfPacks.indexOf(pack);
      if (index > -1) { 
          listOfPacks.splice(index, 1); 
      }
      delete examsOfPacks[pack]
      SetBasketPacks([...listOfPacks])
      window.localStorage.setItem("BasketPacks",JSON.stringify([...listOfPacks]))
      SetExamsPerProduct({...examsOfPacks})
      setOnetime4(true)
      SetAdded(false)
      //setRecalcFonasa(true)
    }
  }

  async function checkCoupon() {
    setLoading(true)

    MySwal.fire({
      position: "center",
      html: 
      <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Validando Cupón...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
      </div>,
      color: "#340066",
      customClass: 'swal-wide',
      showConfirmButton: false,
      width: "100%",
    })

    let str = Coupon.replace(/\s+/g, '');
    let person = 0;
    await fetch("https://ymc-doc-api.azurewebsites.net/validatecoupon", {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        coupon: str
      })
    })
      .then((res) => res.json()).then((responseData) => {
        if (responseData)
          return person = responseData
        else
          return person = false
      })
      .catch(error => console.log(error))
    if (person.discount) {
      //console.log(person)
      let pricereduce = PriceTotal * (100 - person.discount) / 100
      setDiscount((100 - person.discount) / 100)
      setDiscounted(person.discount)
      setPriceTotal(pricereduce)
      document.getElementById("valcoup").innerHTML = "Cupón validado";
      setValidCoupon(true)
      setLoading(false)
      MySwal.close()
      if(person.discount === 100)
        SetPurchased(true)
    }
    else {
      document.getElementById("valcoup").innerHTML = "Cupón inválido";
      setLoading(false)
      MySwal.close()
    }
  } 

  //const executeScroll = () => document.getElementById('go-to-examedi').scrollIntoView();

  function ValidateEmail(input) {

    let accepted = document.getElementById('TOS')

    //if(ExamediSelected) {
    //  if(ExamediAllowed && ExamediCommune !== "" && ExamediRegion !== "" && isPhoneValid) {
    //    setExamediIncomplete(false)
    //  } else {
    //    setExamediIncomplete(true)
    //    SetExamediWrong(true)
    //    if(window.innerWidth <= 920) {
    //      executeScroll()
    //    }
    //    setTOSMissing(false)
    //    return
    //  }
    //} else {
    //  setExamediIncomplete(false)
    //}

    if(OrderExamsCodes.filter((Item) => examslist[Item].emission === 'Imagenología' | examslist[Item].emission === 'Procedimientos').length > 32 || OrderExamsCodes.filter((Item) => examslist[Item].emission === "Laboratorio").length > 32) {
      return MySwal.fire({
        icon: "error",
        showConfirmButton:false,
        html: 
          <div className="FullAlertWidth2" style={{maxWidth:"590px", paddingInline:"3vw"}}>
              <h3 className="FullAlertTitle">Límite de exámenes excedido</h3>
              <div className="FullAlertSubtitle" style={{color:"#6633FF"}}>No se permite tener más de 32 exámenes por departamento en su orden médica. Por favor vuelva atrás y reduzca su selección.</div>
              <div className='FullAlertButtonFlex'>
                <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton FullAlertButton" style={{maxWidth:"190px"}} onClick={() => {MySwal.close();}}>
                  Volver
                </div>
              </div>
          </div>,
      })
    }

    if(input) {
        if(accepted.checked) {
            createPreference()
            return 
        } else {
            setTOSMissing(true)
            return
        }

    } else {
        if(accepted.checked) {
            SetPurchased(true)
            Navigate("/orden-medica/descargar-orden")
            return 
        } else {
            setTOSMissing(true)
            return
        }
    }
  }

  useEffect(() => {
    if((numberOfBlocks !== BasketPacks.length && (BasketPacks.length !== 0 || RelatedExams.length !== 0)) || onetime4) {
      let totalExams = []
      let payment = 0
      let packs = JSON.parse(window.localStorage.getItem('BasketPacks'))
      let exams = JSON.parse(window.localStorage.getItem('ExamsPerProduct'))
      for(let i = 0; i<packs.length; i++) {
        payment += exams[packs[i]].price
        totalExams = totalExams.concat(exams[packs[i]].exams)
      }
    
      if(RelatedExams.length !== 0) {
        totalExams = totalExams.concat(RelatedExams)
        payment += 990
      }
      setPriceTotal(payment)
      setOrderExamsCodes([...new Set(totalExams)])

      if(ValidCoupon & onetime2) {
        setPriceTotal(payment * Discount)
        setOnetime2(false)
      }

      setNumberOfBlocks(packs.length)

      if(onetime4) setOnetime4(false)
    }
  }, [numberOfBlocks, BasketPacks, RelatedExams, onetime4, setOrderExamsCodes, ValidCoupon, onetime2, Discount])

  //function showExamedi() {
  //  let tmp = document.getElementById("Examedi")
  //  let tmp2 = document.getElementById("ExamediForm")
  //  if(tmp.checked) {
  //    tmp2.className = tmp2.className.replace(" OrderCheckoutInnerDiv2BlockHidden", "");
  //    SetExamediSelected(true)
  //    setOneTime(true)
  //  } else {
  //    tmp2.className += " OrderCheckoutInnerDiv2BlockHidden"
  //    SetExamediSelected(false)
  //  }
  //}

  useEffect(() => {
    if(onetime) {
      setOrderExamsCodes([...RelatedExams])
      setDiscounted(0)
      //SetExamediWrong(false)
      setOnetime(false)
      if(window.localStorage.getItem('BasketPacks') && JSON.parse(window.localStorage.getItem('BasketPacks')).length !== 0) {
        setOnetime4(true)
      }
    }
  }, [onetime, setOrderExamsCodes, RelatedExams, setDiscounted])

  return (
    <div className="OrderCheckoutOuterDiv">
    {RelatedExams.length === 0 && BasketPacks.length === 0 ?
      <div className="UserProfileInnerDiv">
        <div className="UserProfileWhiteBox OrderCheckoutDivEmpty">
          <div className="UserProfilePageUpTitle">Órdenes Médicas</div>
          <div className="OrderCheckoutTitleFlex">
            <img className="OrderCheckoutTitlePlusIcon" alt="" src="https://static.yomecontrolo.cl/public/icons/YMC_PlusIcon.svg" />
            <h2 className="OrderCheckoutTitle">Órdenes Médicas Online</h2>
          </div>
          <div className='OrderCheckoutEmptyBlock'>
            <img className='OrderCheckoutEmptyBlockImage' alt="" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
            <div className='OrderCheckoutEmptyBlockTexts'>
              <h3 className="OrderCheckoutTitle">No posees ningún examen añadido a tu orden médica</h3>
              <div className="OrderCheckoutEmptyInfo">¿No sabes cuales? Explora nuestros packs de exámenes:</div>
              <div className="GeneralPurpleButtonFlex OrderCheckoutEmptyButton" onClick={() => Navigate("/packs-de-examenes")}>Ver Packs de Exámenes</div>
              <div className="OrderCheckoutEmptyInfo">O crea una orden personalizada contestando un par de preguntas:</div>
              <div className="GeneralPurpleButtonFlex OrderCheckoutEmptyButton" onClick={() => Navigate("/recomendador-de-examenes")}>Obtén tu Recomendación de Exámenes</div>
            </div>
          </div>
        </div>
      </div>
    :
    <div className="UserProfileInnerDiv">
      <div className='UserProfileWhiteBox PacksSelectWhiteBlock' id="FullForm" style={{color:"#330066", marginBlockEnd:"20px"}}>
      <div className="UserProfilePageUpTitle">Órdenes Médicas</div>
      <div className="OrderCheckoutTitleFlex">
        <img className="OrderCheckoutTitlePlusIcon" alt="" src="https://static.yomecontrolo.cl/public/icons/YMC_PlusIcon.svg" />
        <h2 className="OrderCheckoutTitle">Órdenes Médicas Online</h2>
      </div>
      <div className={PreferenceID ? 'OrderCheckoutWhiteBlock2' : 'OrderCheckoutWhiteBlock'}>
        <div className="OrderCheckoutInnerDiv1">
      <div className="OrderCheckoutDiv" id="Step1">
        <h4 className="OrderCheckoutUpperTitleText">Detalle de exámenes</h4>
        {RelatedExams.length === 0 ?
        null
        :
        <div>
        <div className="OrderCheckoutInnerBox">
          <div className="OrderCheckoutInnerBoxUpper">
          <div className="OrderCheckoutInnerBoxLeftImage" style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 75%),url('https://static.yomecontrolo.cl/public/img/packs/CM00YMC001.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
          <div className="OrderCheckoutInnerBoxUpperRow">
            <div className="OrderCheckoutInnerBoxUpperRowText">Exámenes Recomendados</div>
            <div className="OrderCheckoutInnerBoxUpperRow2">
              <div className="OrderCheckoutInnerBoxUpperRowIcons">
                {RelatedExams.some((ex) => examslist[ex].emission === "Laboratorio") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamLaboratoryIcon.svg" />
                : null}
                {RelatedExams.some((ex) => examslist[ex].emission === "Imagenología" || examslist[ex].emission === "Procedimientos") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamImagenologyIcon.svg" />
                : null}
                {RelatedExams.some((ex) => examslist[ex].emission === "Derivaciones") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamDerivationsIcon.svg" />
                : null}
              </div>
              <div className="OrderCheckoutInnerBoxUpperRowPackPrice">$ 990</div>
            </div>
            <div className="OrderCheckoutInnerBoxUpperRow2">
              <div className="OrderCheckoutInnerBoxLowerLinesLeftText">Exámenes: ({RelatedExams.length})</div>
              {ExamDetails & OpenBlock === 0 ? 
              <div className="OrderCheckoutInnerBoxShowDetails" onClick={() => ShowDetails(0,"PackDetails".concat(0),"PackDots".concat(0),RelatedExams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="OrderCheckoutInnerBoxShowDetailsText">Ocultar Detalle</div>
                <img className="OrderCheckoutInnerBoxEyeIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueOpenEyeIcon.svg" />
              </div>
              :
              <div className="OrderCheckoutInnerBoxShowDetails" onClick={() => ShowDetails(0,"PackDetails".concat(0),"PackDots".concat(0),RelatedExams.filter(obj => examslist[obj].emission !== "Derivaciones" && examslist[obj].emission !== ""))}>
                <div className="OrderCheckoutInnerBoxShowDetailsText">Mostrar Detalle</div>
                <img className="OrderCheckoutInnerBoxEyeIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueClosedEyeIcon.svg" />
              </div> }
            </div>

          <div className="OrderCheckoutInnerBoxLowerLines OrderCheckoutHidden" id={"PackDetails".concat(0)}>
          {packOne.length === 0 ?
            null :
            <>

            <div className="OrderCheckoutInnerBoxExamLinesFlex">
              {shown === 0 ?
              null
              :
              <div className="OrderCheckoutInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(-3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='OrderCheckoutInnerBoxExamLineLeftArrow text-end fa-rotate-180'
                />
              </div>
  }
              <div className="OrderCheckoutInnerBoxExamLineExamBlockContainer">
              {examsShown.map((exam) => (
              
                <div className="OrderCheckoutInnerBoxExamLineExamBlock" key={exam}>
                  {OpenBlock === 0 ? 
                  <div className="OrderCheckoutInnerBoxExamLineExamNameFlex">
                    <div className="OrderCheckoutInnerBoxExamLineExamName">{packOne[exam].name}</div>
                  </div>
                  : null}
                  {packOne[exam] ?
                  <div className="OrderCheckoutInnerBoxExamLineExamDescription">{packOne[exam].description}</div>
                  : null }
                </div>
              
              ))}
              </div>
              {shown >= packOne.length-3 ?
              null:
              <div className="OrderCheckoutInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='OrderCheckoutInnerBoxExamLineRightArrow text-end'
                />
              </div>
  }
            </div>
            <div className="OrderCheckoutInnerBoxLowerLinesPageDots" id={"PackDots".concat(0)}>
            {OpenBlock === 0 ?
            <>
              <div className="OrderCheckoutInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
              {[...Array(Math.ceil(packOne.length / 3)-1).keys()].map((dots) => (
              <div className="OrderCheckoutInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
              ))}
              </>
              : null}
              
            </div>
            </>
            }
            {packOneDer.length === 0 ?
            null :
            <>
            <div className="OrderCheckoutInnerBoxLowerLinesFlex">
              <div className="OrderCheckoutInnerBoxLowerLinesLeftFlex">
                <div className="OrderCheckoutInnerBoxLowerLinesLeftText">Derivaciones:</div>
              </div>
            </div>
            <div className="OrderCheckoutInnerBoxRiskLines">

              {packOneDer.map((exam) => (
              
              <div className="OrderCheckoutInnerBoxExamLineExamBlock" key={exam}>
                <div className="OrderCheckoutInnerBoxExamLineExamNameFlex">
                  <div className="OrderCheckoutInnerBoxExamLineExamName">{exam.name}</div>
                </div>
              </div>
            
            ))}

            </div>
            </>
              }
          </div>
          <div className="OrderCheckoutInnerBoxHorizontalLine"></div>
          </div>
          <img className="OrderCheckoutInnerBoxUpperRowTrashcanIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueTrashIcon.svg"
              onClick={() => MySwal.fire({
                title: "Desea eliminar el pack de su Orden Médica?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                confirmButtonColor: "#6633FF"
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    EliminateBlock("Recommended")
                    MySwal.fire({
                      icon: "success",
                      iconColor: "#6633FF",
                      title: "El pack fue eliminado con éxito",
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                })}/>
            </div>
        </div>
        </div>
  }



      {[...Array(BasketPacks.length).keys()].map((IndividualPack) => (
        <div key={IndividualPack}>
        <div className="OrderCheckoutInnerBox">
          <div className="OrderCheckoutInnerBoxUpper">
          <div className="OrderCheckoutInnerBoxLeftImage" style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 75%),url('https://static.yomecontrolo.cl/public/img/packs/"+ BasketPacks[IndividualPack] +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
          <div className="OrderCheckoutInnerBoxUpperRow">
            <div className="OrderCheckoutInnerBoxUpperRowText">{packslist[BasketPacks[IndividualPack]].name}</div>
            <div className="OrderCheckoutInnerBoxUpperRow2">
              <div className="OrderCheckoutInnerBoxUpperRowIcons">
                {(ExamsPerProduct[BasketPacks[IndividualPack]] && ExamsPerProduct[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Laboratorio")) || (JSON.parse(window.localStorage.getItem('ExamsPerProduct')))[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Laboratorio") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamLaboratoryIcon.svg" />
                : null}
                {(ExamsPerProduct[BasketPacks[IndividualPack]] && ExamsPerProduct[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Imagenología" || examslist[ex].emission === "Procedimientos")) || (JSON.parse(window.localStorage.getItem('ExamsPerProduct')))[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Imagenología" || examslist[ex].emission === "Procedimientos") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamImagenologyIcon.svg" />
                : null}
                {(ExamsPerProduct[BasketPacks[IndividualPack]] && ExamsPerProduct[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Derivaciones")) || (JSON.parse(window.localStorage.getItem('ExamsPerProduct')))[BasketPacks[IndividualPack]].exams.some((ex) => examslist[ex].emission === "Derivaciones") ?
                  <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueExamDerivationsIcon.svg" />
                : null}
              </div>
              {ExamsPerProduct[BasketPacks[IndividualPack]] && ExamsPerProduct[BasketPacks[IndividualPack]].price === 0 ?
              <div className="OrderCheckoutInnerBoxUpperRowPackPrice">Gratis</div>
              :
              <div className="OrderCheckoutInnerBoxUpperRowPackPrice">$ {ExamsPerProduct[BasketPacks[IndividualPack]] ? ExamsPerProduct[BasketPacks[IndividualPack]].price : (JSON.parse(window.localStorage.getItem('ExamsPerProduct')))[BasketPacks[IndividualPack]].price}</div>
  }
            </div>
            <div className="OrderCheckoutInnerBoxUpperRow2">
              <div className="OrderCheckoutInnerBoxLowerLinesLeftText">Exámenes: ({ExamsPerProduct[BasketPacks[IndividualPack]] ? ExamsPerProduct[BasketPacks[IndividualPack]].exams.length : (JSON.parse(window.localStorage.getItem('ExamsPerProduct')))[BasketPacks[IndividualPack]].exams.length})</div>
              {ExamDetails & OpenBlock === IndividualPack+1 ? 
              <div className="OrderCheckoutInnerBoxShowDetails" onClick={() => ShowDetails(IndividualPack+1,"PackDetails".concat(IndividualPack+1),"PackDots".concat(IndividualPack),IndividualPack)}>
                <div className="OrderCheckoutInnerBoxShowDetailsText">Ocultar</div>
                <img className="OrderCheckoutInnerBoxEyeIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueOpenEyeIcon.svg" />
              </div>
              :
              <div className="OrderCheckoutInnerBoxShowDetails" onClick={() => ShowDetails(IndividualPack+1,"PackDetails".concat(IndividualPack+1),"PackDots".concat(IndividualPack),IndividualPack)}>
                <div className="OrderCheckoutInnerBoxShowDetailsText">Mostrar Detalle</div>
                <img className="OrderCheckoutInnerBoxEyeIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueClosedEyeIcon.svg" />
              </div> }
            </div>
          <div className="OrderCheckoutInnerBoxLowerLines OrderCheckoutHidden" id={"PackDetails".concat(IndividualPack+1)}>
            {packOne.length === 0 ?
            null :
            <>
            <div className="OrderCheckoutInnerBoxExamLinesFlex">
              {shown === 0 ?
              null
              :
              <div className="OrderCheckoutInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(-3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='OrderCheckoutInnerBoxExamLineLeftArrow text-end fa-rotate-180'
                />
              </div>
  }
              <div className="OrderCheckoutInnerBoxExamLineExamBlockContainer">
              {examsShown.map((exam) => (
              
                <div className="OrderCheckoutInnerBoxExamLineExamBlock" key={exam}>
                  {OpenBlock === IndividualPack+1 ? 
                  <div className="OrderCheckoutInnerBoxExamLineExamNameFlex">
                    <div className="OrderCheckoutInnerBoxExamLineExamName">{packOne[exam].name}</div>
                  </div>
                  : null}
                  {packOne[exam] ?
                  <div className="OrderCheckoutInnerBoxExamLineExamDescription">{packOne[exam].description}</div>
                  : null }
                </div>
              
              ))}
              </div>
              {shown >= packOne.length-3 ?
              null:
              <div className="OrderCheckoutInnerBoxExamLineArrowBlock" onClick={() => ChangeExamPage(3,packOne.length-3)}>
                <FontAwesomeIcon 
                  icon={faArrowRightLong} 
                  className='OrderCheckoutInnerBoxExamLineRightArrow text-end'
                />
              </div>
  }
            </div>
            <div className="OrderCheckoutInnerBoxLowerLinesPageDots" id={"PackDots".concat(IndividualPack)}>
            {OpenBlock === IndividualPack+1 ?
            <>
              <div className="OrderCheckoutInnerBoxLowerLinesIndividualPageDot ActiveDot" id="pageDot1"></div>
              {[...Array(Math.ceil(packOne.length / 3)-1).keys()].map((dots) => (
              <div className="OrderCheckoutInnerBoxLowerLinesIndividualPageDot" key={'pageDot'.concat(dots+2)} id={'pageDot'.concat(dots+2)}></div>
              ))}
              </>
              : null}
              
            </div>
            </>
            }
            {packOneDer.length === 0 ?
            null :
            <>
            <div className="OrderCheckoutInnerBoxLowerLinesFlex">
              <div className="OrderCheckoutInnerBoxLowerLinesLeftFlex">
                <div className="OrderCheckoutInnerBoxLowerLinesLeftText">Derivaciones:</div>
              </div>
            </div>
            <div className="OrderCheckoutInnerBoxRiskLines">

              {packOneDer.map((exam) => (
              
              <div className="OrderCheckoutInnerBoxExamLineExamBlock" key={exam}>
                <div className="OrderCheckoutInnerBoxExamLineExamNameFlex">
                  <div className="OrderCheckoutInnerBoxExamLineExamName">{exam.name}</div>
                </div>
              </div>
            
            ))}

            </div>
            </>
              }
          </div>
          <div className="OrderCheckoutInnerBoxHorizontalLine"></div>
          </div>
          <img className="OrderCheckoutInnerBoxUpperRowTrashcanIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueTrashIcon.svg"
              onClick={() => MySwal.fire({
                title: "Desea eliminar el pack de su Orden Médica?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                confirmButtonColor: "#6633FF"
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    EliminateBlock(BasketPacks[IndividualPack])
                    MySwal.fire({
                      icon: "success",
                      iconColor: "#6633FF",
                      title: "El pack fue eliminado con éxito",
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                })}/>
                </div>
        </div>
      </div>
  ))}
      </div>
  
        <div className="OrderCheckoutDivHidden" id="Step2">
          <h4 className="OrderCheckoutUpperTitleText">Métodos de Pago</h4>
            <Payment
              initialization={{amount: PriceTotal, preferenceId: PreferenceID}}
              customization={customization}
              onSubmit={onSubmit}
              onReady={onReady}
              onError={onError}
              />
        </div>
      </div>
          {/*
            <div className="OrderCheckoutInnerDiv2">
              <div className="OrderCheckoutInnerDiv2Flex">
                <img className="OrderCheckoutInnerDiv2ExamediLogo" alt='' src="https://static.yomecontrolo.cl/public/icons/Examedi.svg" />
                <div className="OrderCheckoutInnerDiv2Title">Con Examedi podrás realizar los exámenes en la comodidad de tu hogar o incluso oficina.</div>
              </div>
              <div className="OrderCheckoutInnerDiv2Subtitle">Al finalizar la compra Examedi te contactará para presentar una cotización.</div>
              <div className="OrderCheckoutInnerDiv2Flex2">
                <input type="checkbox" name="useExamedi" className="OrderCheckoutInnerDiv2Checkbox" id="Examedi" onClick={() => showExamedi()}/>
                <div className="OrderCheckoutInnerDiv2CheckboxText">Quiero que Examedi me envíe cotización. </div>
              </div>
              <div className="OrderCheckoutInnerDiv2LowerBlock OrderCheckoutInnerDiv2BlockHidden" id='ExamediForm'>
                <div className="OrderCheckoutInnerDiv2LowerBlockInstructions">Seleccione la región y comuna donde se realizaría el servicio (hogar u oficina). Solo se muestran las comunas en cobertura, si no encuentra su comuna de momento no puede optar al servicio. En tal caso, por favor des-seleccionar el checkbox arriba de este texto.</div>
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Región"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="RegionSelect" 
                  style={{ border: ExamediWrong && ExamediRegion === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => {SetExamediRegion(e.target.value); SetExamediCommune("")}}>
                    <option key="Region0" value="">Seleccione Región</option>
                    <option key="Region1" value="RM">Región Metropolitana</option>
                    <option key="Region2" value="AN">Antofagasta</option>
                    <option key="Region3" value="CO">Coquimbo</option>
                    <option key="Region4" value="VA">Valparaíso</option>
                    <option key="Region5" value="BI">BioBío</option>
                  </select>
                </div>
                {ExamediRegion === "RM" ?
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Comuna"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="CommuneSelect" 
                  style={{ border: ExamediWrong && ExamediCommune === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => SetExamediCommune(e.target.value)}>
                    <option key="Commune0" value="">Seleccione Comuna</option>
                    {communeRM.map((commune) => (
                      <option key={commune} value={commune}>{commune}</option>
                    ))}
                  </select>
                </div>
                : ExamediRegion === "AN" ?
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Comuna"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="CommuneSelect" 
                  style={{ border: ExamediWrong && ExamediCommune === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => SetExamediCommune(e.target.value)}>
                    <option key="Commune0" value="">Seleccione Comuna</option>
                    {communeAN.map((commune) => (
                      <option key={commune} value={commune}>{commune}</option>
                    ))}
                  </select>
                </div>
                : ExamediRegion === "CO" ?
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Comuna"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="CommuneSelect" 
                  style={{ border: ExamediWrong && ExamediCommune === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => SetExamediCommune(e.target.value)}>
                    <option key="Commune0" value="">Seleccione Comuna</option>
                    {communeCO.map((commune) => (
                      <option key={commune} value={commune}>{commune}</option>
                    ))}
                  </select>
                </div>
                : ExamediRegion === "VA" ?
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Comuna"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="CommuneSelect" 
                  style={{ border: ExamediWrong && ExamediCommune === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => SetExamediCommune(e.target.value)}>
                    <option key="Commune0" value="">Seleccione Comuna</option>
                    {communeVA.map((commune) => (
                      <option key={commune} value={commune}>{commune}</option>
                    ))}
                  </select>
                </div>
                : ExamediRegion === "BI" ?
                <div className="OrderCheckoutInnerDiv2LowerBlockSelector">
                  <select defaultValue={"Seleccione Comuna"} className='OrderCheckoutInnerDiv2LowerBlockSelectorTile rounded-2' id="CommuneSelect" 
                  style={{ border: ExamediWrong && ExamediCommune === "" ? "red solid 1px" : "#CCCCFF solid 2px" }} onChange={(e) => SetExamediCommune(e.target.value)}>

                    <option key="Commune0" value="">Seleccione Comuna</option>
                    {communeBI.map((commune) => (
                      <option key={commune} value={commune}>{commune}</option>
                    ))}
                  </select>
                </div>
                : null}
                {ExamediCommune !== "" ?
                <>
                  <div className="OrderCheckoutInnerDiv2LowerBlockInputData">
                    <div className="OrderCheckoutInnerDiv2LowerBlockInputNumber">+56</div>
                    <input
                      value={Phone}
                      className="OrderCheckoutInnerDiv2LowerBlockInput"
                      style={{ border: ExamediWrong && Phone.length < 9 || Phone.length > 11 ? "red solid 1px" : "#CCCCFF solid 2px" }}
                      id="YMCPhone"
                      maxLength={20}
                      type="tel"
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Ingresa tu celular (9 8765 4321)" />
                  </div>
                  <div className="OrderCheckoutInnerDiv2Flex2">
                    <input type="checkbox" name="acceptTOS" className="OrderCheckoutInnerDiv2Checkbox" id="ExamediAllowed" defaultChecked={ExamediAllowed ? true : false} onClick={() => SetExamediAllowed(!ExamediAllowed)}/>
                    <div className="OrderCheckoutInnerDiv2CheckboxText">Autorizo a Yo Me Controlo (YMC) que comparta mi Nombre, Celular y exámenes solicitados con Examedi. </div>
                  </div>
                  {ExamediFonasa.length !== 0 ?
                  <>
                    <div className="OrderCheckoutInnerDivPriceFlex">
                      <div className="OrderCheckoutInnerDivPriceFlexText">Bonificación aprox. con Fonasa:</div>
                      <div className="OrderCheckoutInnerDivPriceFlexText2">${ExamediFonasa.price}</div>
                    </div>
                    <div className="OrderCheckoutInnerDivPriceFlexLowerText">*La cifra anterior incluye {ExamediFonasa.acc}/{ExamediFonasa.total} de tus exámenes solicitados.</div>
                  </>
                    : null
                  }
                </>
                : null}
                {ExamediWrong ?
                  <>
                    {ExamediRegion === "" ?
                    <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos faltantes o des-seleccionar la opción Examedi.
                    <br/>- Seleccione su región.</div>
                    : ExamediCommune === "" ?
                    <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos faltantes o des-seleccionar la opción Examedi.
                    <br/>- Seleccione su comuna.</div>
                    : Phone.length < 9 || Phone.length > 11 ?
                    <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos faltantes o des-seleccionar la opción Examedi.
                    <br/>- Ingrese un número de teléfono válido.</div>
                    : !ExamediAllowed ?
                    <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos faltantes o des-seleccionar la opción Examedi.
                    <br/>- Seleccione el último checkbox para autorizar que Examedi lo pueda contactar.</div>
                    : 
                    null}
                  </>
                  : null}
              </div>
            </div>
            */}

        {RelatedExams.length === 0 && BasketPacks.length === 0 ?
          null :
          
      <div className='OrderCheckoutBasketGetOrderDiv'>
        <div className='OrderCheckoutBasketGetOrderDivUpperBlock'>
          <div className='OrderCheckoutBasketGetOrderTitle'>Usuario</div>
          <div className='OrderCheckoutBasketGetOrderDivUpperBlockFlex'>
            <h4 className='OrderCheckoutBasketGetOrderDivUpperBlockFlexLeft'>{decodedToken.name[0]}</h4>
            <h4 className='OrderCheckoutBasketGetOrderDivUpperBlockFlexRight'>Generar Orden Médica para {decodedToken.name}</h4>
          </div>
        </div>
        <div className='OrderCheckoutBasketGetOrderDivLowerBlock'>
          <div className='OrderCheckoutBasketGetOrderTitle'>Pago</div>
          {PriceTotal === 0 ?
          <>
            <div className='OrderCheckoutBasketCouponDiv'>
              <div className='OrderCheckoutBasketCouponText'>Ingresar código de descuento</div>
              <div className='OrderCheckoutBasketCouponFlex'>
                <input
                  value={Coupon}
                  className="OrderCheckoutBasketCouponInput rounded-1"
                  style={{ border: ValidCoupon === false ? "red solid 1px" : "#cff9ff solid 1px", width: "100%", paddingInline: "1vh", marginInlineEnd: "0.5vw" }}
                  id="YMCCoupon"
                  maxLength={20}
                  onChange={(e) => setCoupon(e.target.value)}
                  placeholder="-"
                  disabled />
                <div className='OrderCheckoutBasketCouponValidateButtonDisabled' onClick={() => null}>Validar</div>
              </div>
              <span id="valcoup" className='ValidOrNotCoupon' ></span>
            </div>
            <div className='OrderCheckoutBasketCouponDiv'>
              <div className='OrderCheckoutBasketTOSFlex'>
                <input type="checkbox" name="acceptTOS" className="OrderCheckoutBasketTOSCheck" id="TOS" />&ensp;
                <div className='OrderCheckoutBasketCouponText'>Acepto los <a className='OrderCheckoutBasketEmailInfoLink' href="https://static.yomecontrolo.cl/public/pdf/GENERAL-TERMS-YMC.pdf" target="_blank" rel="noreferrer" >términos y condiciones</a>.</div>
              </div>
              <div className='OrderCheckoutBasketEmailInfoText'>Enviaremos un correo con la boleta y un enlace para que puedas recuperar tu orden médica.</div>
              <span id="valemail" className='ValidOrNotEmail' style={{ color: "red", fontWeight: "500" }}></span>
            </div>
            {TOSMissing ?
              <div className='OrderCheckoutBasketTOSAlert'>Por favor aceptar términos y condiciones</div>
            : null}
            {/*ExamediIncomplete ?
              <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos en el bloque de Examedi o des-seleccionar la opción.</div>
            : null*/}
            <div className='OrderCheckoutBasketGetOrderButton' onClick={() => ValidateEmail(false)}>Obtén tu Órden Médica</div>
          </>
          : !PreferenceID ?
          <>
          <div className='OrderCheckoutBasketCouponDiv'>
            <div className='OrderCheckoutBasketCouponText'>Ingresar código de descuento</div>
            <div className='OrderCheckoutBasketCouponFlex'>
              <input
                value={Coupon}
                className="OrderCheckoutBasketCouponInput rounded-1"
                style={{ border: ValidCoupon === false ? "red solid 1px" : "#cff9ff solid 1px", width: "100%", paddingInline: "1vh", marginInlineEnd: "0.5vw" }}
                id="YMCCoupon"
                maxLength={20}
                onChange={(e) => setCoupon(e.target.value)}
                placeholder="-" />
              {Loading ?
              <div className='OrderCheckoutBasketCouponValidateButtonDisabled'>Validando...</div>
              :
              <div className='OrderCheckoutBasketCouponValidateButton' onClick={() => checkCoupon()}>Validar</div>
                }
            </div>
            <span id="valcoup" className='ValidOrNotCoupon' ></span>
          </div>
          <div className='OrderCheckoutBasketCouponDiv'>
            <div className='OrderCheckoutBasketTOSFlex'>
              <input type="checkbox" name="acceptTOS" className="OrderCheckoutBasketTOSCheck" id="TOS" />&ensp;
              <div className='OrderCheckoutBasketCouponText'>Acepto los <a className='OrderCheckoutBasketEmailInfoLink' href="https://static.yomecontrolo.cl/public/pdf/GENERAL-TERMS-YMC.pdf" target="_blank" rel="noreferrer" >términos y condiciones</a>.</div>
            </div>
            <div className='OrderCheckoutBasketEmailInfoText'>Enviaremos un correo con la boleta y un enlace para que puedas recuperar tu orden médica.</div>
          </div>
          <div className='OrderCheckoutBasketTotalFlex'>
            <div className='OrderCheckoutBasketPriceText'>Total</div>
            <div className='OrderCheckoutInnerBoxUpperRowPackPrice'>${PriceTotal}</div>
          </div>
          {TOSMissing ?
            <div className='OrderCheckoutBasketTOSAlert'>Por favor aceptar términos y condiciones.</div>
          : null}
          {/*ExamediIncomplete && ExamediSelected && (!ExamediAllowed || ExamediCommune === "" || ExamediRegion === "" || Phone.length < 9 || Phone.length > 11) ?
            <div className='OrderCheckoutBasketTOSAlert'>Por favor completar los campos en el bloque de Examedi o des-seleccionar la opción.</div>
          : null*/}
          { Loading2 ?
          <div className='OrderCheckoutBasketGetOrderButton'>Cargando...</div>
          :
          <div className='OrderCheckoutBasketGetOrderButton' onClick={() => ValidateEmail(true)}>Pasar a Pagar</div>
          }
          </>
          : 
          <div className='OrderCheckoutBasketTotalFlex'>
            <div className='OrderCheckoutBasketPriceText'>Total</div>
            <div className='OrderCheckoutInnerBoxUpperRowPackPrice'>${PriceTotal}</div>
          </div>
}
        </div>
        </div>
}
          </div>
          </div>
          </div>
        }
    </div>
  );
}

export default OrderCheckout